export const MARKET_TABS = [
  {
    className: 'height-5 bg-8',
    link: '/market/government',
    head: 'Government',
  },

  {
    className: 'height-5 bg-7',
    link: '/market/education',
    head: 'Education',
  },

  {
    className: 'height-5 bg-25',
    link: '/market/house-of-worship',
    head: 'House of Worship',
  },

  {
    className: 'height-5 bg-18',
    link: '/market/private-commercial',
    head: 'Private / Commercial',
  }
]